module.exports = __webpack_public_path__ + "827f5ea84a46715cca4d8e1809d02497.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/map.png
// module id = 170
// module chunks = 0